import React from "react";
import classNames from "classnames";
import styles from "./RotatingCard.module.scss";

export default function CardExampleCardRotating({
  frontTitle,
  frontDescription,
  backTitle,
  backDescription,
  frontImage,
  backImage
}) {
  React.useEffect(() => {
    const addStylesForRotatingCards = () => {
      const rotatingCards = document.getElementsByClassName(styles.cardRotate);
      for (let i = 0; i < rotatingCards.length; i++) {
        const rotatingCard = rotatingCards[i];
        const cardFront = rotatingCard.getElementsByClassName(styles.front)[0];
        const cardBack = rotatingCard.getElementsByClassName(styles.back)[0];
        var cardWidth = rotatingCard.parentElement.offsetWidth;
        var cardHeight = cardWidth; // Keep it square
        rotatingCard.style.height = cardHeight + "px";
        cardFront.style.height = cardHeight + "px";
        cardFront.style.width = cardWidth + "px";
        cardBack.style.height = cardHeight + "px";
        cardBack.style.width = cardWidth + "px";
      }
    };
    
    addStylesForRotatingCards();
    window.addEventListener("resize", addStylesForRotatingCards);
    return () => window.removeEventListener("resize", addStylesForRotatingCards);
  }, []);

  return (
    <div className={styles.rotatingCardContainer}>
      <div className={styles.cardRotate}>
        <div
          className={classNames(styles.front, styles.wrapperBackground)}
          style={{
            backgroundImage: `url('${frontImage || '/img/examples/card-blog5.jpg'}')`
          }}
        >
          <div className={styles.cardBodyRotate}>
            <h5 className={styles.cardTitleWhite}>{frontTitle}</h5>
          </div>
        </div>
        <div
          className={classNames(styles.back, styles.wrapperBackground)}
          style={{
            backgroundImage: `url('${backImage || frontImage || '/img/examples/card-blog5.jpg'}')`
          }}
        >
          <div className={styles.cardBodyRotate}>
            <p className={styles.cardDescriptionWhiteBack}>
              {frontDescription}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}